"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorAnnouncementBanner_1 = require("./EditorAnnouncementBanner");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return EditorAnnouncementBanner_1.default; } });
